import { useQuery } from '@tanstack/react-query';

import { QUERY_KEY } from '~common';
import { getRequest, inMemoryJWTService } from '~services';
import { AccountBalancesResponse } from '~types/account-balances.type';

export const useQueryGetAccountBalances = () => {
  return useQuery<AccountBalancesResponse>(
    [QUERY_KEY.GET_ACCOUNT_BALANCES],
    () => {
      return getRequest({
        path: 'api/account-balance/list-by-user',
      });
    },
    {
      enabled: !!inMemoryJWTService.getCurrentToken(),
    },
  );
};
